import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import csvHelper from '../importjsontocsv';
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'cancelPutawayPending',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			// currentPage: 0,
			merchantnameFlt: '',
			listCancelPutawayPendingReportDataforxls: [],
			csvFieldsForXls: {},
			listCancelPutawayPendingReportData: [],
			listCancelPutawayPendingReportDataCsv: [],
			csvFields: [],

			listMerchantIdData: '',
			isLoadingforxls: false,
			show: false,
			download: true,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			totalPage: 0,
			isLoading: false,
			formattedDate: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			productid: '',
			user_type: '',
			orderid: '',
			reportname: '',
			dataFilter2: '',
			limitExeed: false,
			recordLimit: 0,
			Cancelledfromdate: '',
			Cancelledtodate: '',
			Pickedfromdate: '',
			Pickedtodate: '',
			item: {},
			merchant: '',
			listMerchantIdData1: [],
			merchantList: [],
			merchantname: '',
			mid: ''

		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		}
	},
	mounted() {
		this.calldateFunction();
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('cancelPutawayPendingReport.cancelPutAwayPendingReportFile');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getMerchantList();
         }
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				if (userdetail.merchantid != null) {
					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantnameFlt = item.value
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getCancelPutAwayPendingXLSData(3);
			}

		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.Cancelledtodate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.Cancelledfromdate = dt;
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.item = {}
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.getMerchantList();
		// 			// this.getCancelPutAwayPendingData();
		// 		}
		// 	}
		// 	this.listCancelPutawayPendingReportData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getCancelPutAwayPendingData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantIdData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantIdData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
						result.data.forEach(function (item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantIdData.forEach(ele => {
							this.listMerchantIdData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}
				}, error => {
					console.error(error);
				})
		},
		getCancelPutAwayPendingDataSearch() {
			this.currentPage = 1;
			this.pageCount = 0;
			this.searchFlag = true;
			this.getCancelPutAwayPendingData(2);
		},
		//to get client list
		getCancelPutAwayPendingData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var cancelledfr_date = '';
			var cancelledto_date = '';
			var Pickedfr_date = '';
			var Pickedto_date = '';
			// this.ClientErr = '';
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}

			var dataFilter = {};
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.pageCount = 0;
				this.listCancelPutawayPendingReportData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.pageCount = 0;
				this.listCancelPutawayPendingReportData = [];
				return false;
			}

			if (this.Cancelledfromdate == '') {
				cancelledfr_date = '';
			} else {
				cancelledfr_date = this.dateFormat(this.Cancelledfromdate, 0)
			}
			if (this.Cancelledtodate == '') {
				cancelledto_date = '';
			} else {
				cancelledto_date = this.dateFormat(this.Cancelledtodate, 1)
			}

			if (this.Pickedfromdate == '') {
				Pickedfr_date = '';
			} else {
				Pickedfr_date = this.dateFormat(this.Pickedfromdate, 0)
			}
			if (this.Pickedtodate == '') {
				Pickedto_date = '';
			} else {
				Pickedto_date = this.dateFormat(this.Pickedtodate, 1)
			}
			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				productid: this.productid.trim(),
				orderid: this.orderid.trim(),
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromCancelledDateFlt: cancelledfr_date,
				toCancelledDateFlt: cancelledto_date,
				fromPickedDateFlt: Pickedfr_date,
				toPickedDateFlt: Pickedto_date,
				merchantid: this.merchantnameFlt,
				csvData: csvCheck,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPutAwayPendingCancelOrderReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						// this.listCancelPutawayPendingReportDataCsv = [];
						this.show = true;
						this.download = false;
						this.csvFields = {
							'orderid': this.$t('common.orderID'),
							'productid': this.$t('common.productId'),
							'eancode': this.$t('common.eanCode'),
							'productname': this.$t('common.productName'),
							'brand': this.$t('common.brand'),
							'pendingqty': this.$t('cancelPutawayPendingReport.productQty'),
							'rackid': this.$t('common.rackID'),
							'cancelleddate': this.$t('cancelPutawayPendingReport.CancelledDate'),
							'boxid': this.$t('cancelPutawayPendingReport.pickBoxID'),
							'pickeddate': this.$t('cancelPutawayPendingReport.PickedDate'),
							'merchantname': this.$t('common.merchant'),

						};
						var dateFilter = [];
						var skipFilter = ['count', 'merchantid'];
						this.listCancelPutawayPendingReportDataCsv = result.data.data;

						csvHelper.data.jsonToCSV(this.$t('cancelPutawayPendingReport.cancelPutAwayPendingReportFile'), this.listCancelPutawayPendingReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('CancelPutAwayPendingReport', this.listCancelPutawayPendingReportDataCsv, this.csvFields, dateFilter, skipFilter);

					} else {
						this.listCancelPutawayPendingReportData = result.data.data;

						if (result.data.errorCode == -1) {
							this.listCancelPutawayPendingReportData = [];
							this.resultCount = 0;
							this.totalRows = 0;
						} else {
							this.totalRows = Number(result.data.count);
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count;
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getCancelPutAwayPendingXLSData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var cancelledfr_date = '';
			var cancelledto_date = '';
			var Pickedfr_date = '';
			var Pickedto_date = '';
			this.show = true;
			this.download = false;
			var value = '';
			var str = '';
			this.dataFilter2 = [];
			// this.ClientErr = '';
			if (this.Cancelledfromdate == '') {
				cancelledfr_date = '';
			} else {
				cancelledfr_date = this.dateFormat(this.Cancelledfromdate, 0)
			}
			if (this.Cancelledtodate == '') {
				cancelledto_date = '';
			} else {
				cancelledto_date = this.dateFormat(this.Cancelledtodate, 1)
			}

			if (this.Pickedfromdate == '') {
				Pickedfr_date = '';
			} else {
				Pickedfr_date = this.dateFormat(this.Pickedfromdate, 0)
			}
			if (this.Pickedtodate == '') {
				Pickedto_date = '';
			} else {
				Pickedto_date = this.dateFormat(this.Pickedtodate, 1)
			}

			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				productid: this.productid.trim(),
				orderid: this.orderid.trim(),
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				fromCancelledDateFlt: cancelledfr_date,
				toCancelledDateFlt: cancelledto_date,
				fromPickedDateFlt: Pickedfr_date,
				toPickedDateFlt: Pickedto_date,
				merchantid: this.merchantnameFlt,
				csvData: csvCheck,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPutAwayPendingCancelOrderReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listStockReportDataforxls = [];
                            this.csvFieldsForXls[this.$t('common.orderID')]='orderid';
                            this.csvFieldsForXls[this.$t('common.productId')]='productid';
                            this.csvFieldsForXls[this.$t('common.eanCode')]='eancode';
                            this.csvFieldsForXls[this.$t('common.productName')]='productname';
                            this.csvFieldsForXls[this.$t('common.brand')]='brand';
                            this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.productQty')]='pendingqty';
                            this.csvFieldsForXls[this.$t('common.rackID')]='rackid';
                            this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.CancelledDate')]='cancelleddate';
                            this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.pickBoxID')]='boxid';
                            this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.PickedDate')]='pickeddate';
                            this.csvFieldsForXls[this.$t('common.merchant')]='merchantname';

							this.listCancelPutawayPendingReportDataforxls = result.data.data;

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		//   this.pageno = (currentPage - 1) * this.perPage;
		//   this.getCancelPutAwayPendingData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getCancelPutAwayPendingData()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.item = {}
			this.Cancelledfromdate = '',
				this.Cancelledtodate = '',
				this.Pickedfromdate = '',
				this.Pickedtodate = '',
				this.productid = '';
			this.orderid = '';
			this.merchantnameFlt = '';
			this.pageno = 0;
			this.searchFlag = false;
			this.totalRows = 0;
			this.show = false;
			this.download = true;
			this.listCancelPutawayPendingReportData = [];
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/cancelPutawayPendingReport/cancelPutawayPendingReport.component.js